/**
 * params.js
 * Written by: Alex Kasemir
 */

import omit from 'lodash.omit';

import extraActions from '../../actions';

/**
 * Description of the params reducer
 */
const params = (state = {}, action) => {
  switch (action.type) {
    case extraActions.SAVE_QUERY_PARAMS:
      return action.params;
    case extraActions.REMOVE_URL_PARAM:
      return omit(state, action.param);
    default:
      return state;
  }
};

export default params;
